import {useMemo} from 'react'

const useBanner = (options = {}) => {
  const {bamboo} = window
  const banner = useMemo(() => {
    if (!!bamboo) {
      const modal = bamboo.createBanner(options)
      return modal
    }
    return null
  }, [bamboo, options])
  return banner
}
export default useBanner
